import { CardsTableColumnsHead } from './CardsTableColumnsHead';
export default CardsTableColumnsHead;
